import script from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"

import "./Checkbox.vue?vue&type=style&index=0&id=bcee23bc&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcee23bc"]])

export default __exports__